import React from "react";
import Select from "react-select";
import {sweetalert} from "../../App";
import {calculateAge, isBlank, isOnlyWhitespace} from "../../util/ValidationUtil";
import {
    buildRow,
    createCustomFieldDataArray,
    getBoolSelectOptions,
    getBoolSelectVal,
    getLabel,
    getLabelIDsArray,
    getSelectLabels,
    getlabelsFromIDs,
    hideModal,
    parseDate,
    showModalNoOutsideClick
} from "../../util/FormatUtil";
import {isEmptyObject} from "jquery";
import InBetweenOverlay from "../InBetweenOverlay";
import Overlay from "../Overlay";
import { Patient } from "../../types/Patient";
import PhoneInput from 'react-phone-number-input'
import DatePicker from 'react-datepicker';
import moment from "moment";
import Validator, { ValidationEntry } from "../../validation/Validator";
import { Validators } from "../../validation/Validators";


interface PatientManagementState{
    selectedPatient:Patient
    showInBetween
    showLoading
}
interface PatientManagementProps{
    selectedPatient
    onSubmit?
    genders
    ethnicities
    races
    states
    countries
    facilities
}
export class PatientManagementModal extends React.Component<PatientManagementProps, PatientManagementState>{
    public static ID = "sePatientmanagement";
    constructor(props) {
        super(props);
        this.state = {
            showInBetween: false,
            showLoading: false,
            selectedPatient: {
                ID: null,
                uid: "",
                firstName: '',
                middleName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                dateOfBirth: '',
                streetAddress: '',
                city: '',
                state: '',
                zipcode: '',
                country: '',
                county: '',
                streetAddress2: '',
                customerID:null,
                genderID:null,
                ethnicityID:null,
                raceID:null,
                FacilityIDs: [],
                guardianFirstName: '',
                guardianLastName: ''
            } as Patient

        }
    }


    componentWillReceiveProps(nextProps: Readonly<PatientManagementProps>, nextContext: any) {

        if(!isEmptyObject(nextProps.selectedPatient)){
            let patient = nextProps.selectedPatient;


            this.setState({
                selectedPatient: {
                    ID: patient.id,
                    uid: patient.uid,
                    firstName: patient.firstName,
                    middleName: patient.middleName ? patient.middleName : null,
                    lastName: patient.lastName,
                    email: patient.email,
                    phoneNumber: patient.phoneNumber,
                    dateOfBirth: parseDate(patient.dateOfBirth),
                    streetAddress: patient.streetAddress,
                    city: patient.city,
                    state: patient.state,
                    zipcode: patient.zipcode,
                    country: patient.country && patient.country === 'United States of America' ? 'United States' : patient.country ?  patient.country : "",
                    county: patient.county,
                    streetAddress2: patient.streetAddress2 ? patient.streetAddress2 : null,
                    genderID:patient.genderID,
                    ethnicityID: patient.ethnicityID,
                    raceID:patient.raceID,
                    FacilityIDs: patient.FacilityIDs ? getlabelsFromIDs(JSON.parse(patient.FacilityIDs), this.props.facilities) : null,
                    guardianFirstName: patient.guardianFirstName ? patient.guardianFirstName : '',
                    guardianLastName: patient.guardianLastName ? patient.guardianLastName: ''
                } as Patient
            });
        } 
    }

    handleSubmit(){
        this.setState({showLoading: true}) 

        let tempDate = this.state.selectedPatient.dateOfBirth;
        if(typeof tempDate === 'object'){
            tempDate = parseDate(tempDate)
        }

        let patientInfoCopy = JSON.parse(JSON.stringify(this.state.selectedPatient))
        patientInfoCopy.firstName = patientInfoCopy.firstName ? patientInfoCopy.firstName.trim() : null
        patientInfoCopy.middleName = patientInfoCopy.middleName ? patientInfoCopy.middleName.trim() : null
        patientInfoCopy.lastName = patientInfoCopy.lastName ? patientInfoCopy.lastName.trim() : null
        patientInfoCopy.email = patientInfoCopy.email ? patientInfoCopy.email.trim() : null
        patientInfoCopy.dateOfBirth = tempDate ? tempDate : null
        patientInfoCopy.streetAddress = patientInfoCopy.streetAddress ? patientInfoCopy.streetAddress.trim() : null
        patientInfoCopy.streetAddress2 = patientInfoCopy.streetAddress2 ? patientInfoCopy.streetAddress2.trim() : null
        patientInfoCopy.city = patientInfoCopy.city ? patientInfoCopy.city.trim() : null
        patientInfoCopy.zipcode = patientInfoCopy.zipcode ? patientInfoCopy.zipcode.trim() : null
        patientInfoCopy.county = patientInfoCopy.county ? patientInfoCopy.county.trim() : null
        patientInfoCopy.country = patientInfoCopy.country ? patientInfoCopy.country.trim() : null
        patientInfoCopy.phoneNumber = patientInfoCopy.phoneNumber ? patientInfoCopy.phoneNumber.trim() : null
        patientInfoCopy.guardianFirstName = patientInfoCopy.guardianFirstName ? patientInfoCopy.guardianFirstName.trim() : ''
        patientInfoCopy.guardianLastName = patientInfoCopy.guardianLastName ? patientInfoCopy.guardianLastName.trim() : ''
        patientInfoCopy.FacilityIDs = patientInfoCopy.FacilityIDs ? getLabelIDsArray(patientInfoCopy.FacilityIDs) : null

        //validate patient info
        if(!PatientManagementModal.validatePatient(patientInfoCopy)){
            this.setState({showLoading: false})
            return
        }

        //pass back to parent
        this.props.onSubmit(patientInfoCopy)

        this.setState({showLoading: false})
        
    }


    public static validatePatient(s):boolean{        
        let patientValidation = {
            PatientFirstName: s.firstName,
            PatientMiddleName: s.middleName,
            PatientLastName: s.lastName,
            PatientDOB: s.dateOfBirth,
            PatientEmail: s.email,
            PatientGender: s.genderID,
            PatientAddress: s.streetAddress,
            PatientAddress2: s.streetAddress2,
            PatientCity: s.city,
            PatientZip: s.zipcode,
            PatientState: s.state,
            PatientCounty: s.county,
            PatientCountry: s.country,
            PatientPhone: s.phoneNumber,
            PatientEthnicity: s.ethnicityID,
            PatientRace: s.raceID,
            PatientFacilityIDs: s.FacilityIDs,
            GuardianFirstName: s.guardianFirstName,
            GuardianLastName: s.guardianLastName
        }

        let validator = new Validator<any>()
            .withValidation("PatientFirstName", Validators.requireNotBlankAndLength(50, "Patient First Name"))
        if(s.middleName && s.middleName.trim().length > 0){
            validator = validator.withValidation("PatientMiddleName", Validators.requireNotBlankAndLength(50, "Patient Middle Name"))
        }
        if(calculateAge(s.dateOfBirth) < 18){
            validator = validator.withValidation("GuardianFirstName", Validators.requireNotBlankAndLength(50, "Guardian First Name")).withValidation("GuardianLastName", Validators.requireNotBlankAndLength(50, "Guardian Last Name"))
        }
        validator = validator.withValidation("PatientLastName", Validators.requireNotBlankAndLength(50, "Patient Last Name"))
            .withValidation("PatientDOB", Validators.requireDOB(150, "Patient Date of Birth"))
        if(s.email){
            validator = validator.withComposedValidation("PatientEmail", new ValidationEntry(Validators.requireValidEmail("Patient Email")), Validators.requireNotBlankAndLength(100, "Patient Email"))
        }
        if(s.genderID){
            validator = validator.withSimpleValidation("PatientGender", Validators.requireNonNullValidator("Patient Gender"))
        }
        if(s.streetAddress){
            validator = validator.withValidation("PatientAddress", Validators.requireNotBlankAndLength(500, "Patient Address"))
        }
        if(s.streetAddress2 && s.streetAddress2.trim().length > 0){
            validator = validator.withValidation("PatientAddress2", Validators.requireNotBlankAndLength(500, "Street Address cont."))
        }
        if(s.city){
            validator = validator.withValidation("PatientCity", Validators.requireNotBlankAndLength(100, "Patient City"))
        }
        if(s.zipcode){
            validator = validator.withComposedValidation("PatientZip", new ValidationEntry(Validators.requireNotBlankValidator("Patient Zipcode")), new ValidationEntry(Validators.requireZip("Patient Zipcode")))
        }
        if(s.state){
            validator = validator.withSimpleValidation("PatientState", Validators.requireNonNullValidator("Patient State"))
        }
        if(s.county){
            validator = validator.withValidation("PatientCounty", Validators.requireNotBlankAndLength(100, "Patient County"))
        }
        if(s.county){
            validator = validator.withValidation("PatientCounty", Validators.requireNotBlankAndLength(100, "Patient County"))
        }
        if(s.country){
            validator = validator.withSimpleValidation("PatientCountry", Validators.requireNonNullValidator("Patient Country"))
        }
        if(s.FacilityIDs){
            validator = validator.withSimpleValidation("PatientFacilityIDs", Validators.requireNonNullValidator("Patient Facilities"))
        }
        if(s.phoneNumber){
            validator = validator.withComposedValidation("PatientPhone", new ValidationEntry(Validators.requireNonNullValidator("Patient Phone")), new ValidationEntry(Validators.requirePhone("Patient Phone")))
        }
        if(s.ethnicityID){
            validator = validator.withSimpleValidation("PatientEthnicity", Validators.requireNonNullValidator("Patient Ethnicity"))
        }
        if(s.raceID){
            validator = validator.withSimpleValidation("PatientRace", Validators.requireNonNullValidator("Patient Race"))
        }
        let validationResponse = validator.validate(patientValidation);
        if(!validationResponse.success) {
            sweetalert.fire({icon: 'error', title: '', text: validationResponse.error});
            return false
        }

        return true;
    }


    render(){

        // console.log('Patient MGMT Modal props', this.props)
        // console.log('Patient MGMT Modal state', this.state)
        return(
            <>
            <Overlay show_loading={this.state.showLoading} zIndex={100003} />
            <InBetweenOverlay showInBetween={this.state.showInBetween} zIndex={100002} />
            <div className="modal fade form_modal" id={PatientManagementModal.ID} tabIndex={-1} role="dialog"
                 aria-labelledby="result_modal_label"
                 aria-hidden="true">
                <div className="modal-dialog modal-lg modal-xl" role="document">
                    <div className="modal-content">
                    <div className="container-fluid">
                        <div className="modal-header">
                            <h5 className="modal-title" id="result_modal_label">Patient Management</h5>
                            <button  style={{outline: 'none'}} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {buildRow("UID",
                                <input className={"form-control"}
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"UID"}
                                       disabled={true}
                                       value={this.state.selectedPatient.uid}
                                />
                            , 'UID'
                            )}
                            {buildRow("First Name",
                                <input className={"form-control"}
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"First Name"}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedPatient: {
                                                   ...prevState.selectedPatient,
                                                   firstName: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedPatient.firstName}
                                />
                            , 'First Name'
                            )}
                            {buildRow("Middle Name",
                                <input className={"form-control"}
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"Middle Name"}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedPatient: {
                                                   ...prevState.selectedPatient,
                                                   middleName: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedPatient.middleName}
                                />
                            , 'Middle Name'
                            )}
                            {buildRow("Last Name",
                                <input className={"form-control"}
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"Last Name"}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedPatient: {
                                                   ...prevState.selectedPatient,
                                                   lastName: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedPatient.lastName}
                                />
                            , 'Last Name'
                            )}
                            <div className="form-group row" data-toggle={'tooltip'} data-placement={'top'} title={'Patient Date of Birth'}>
                                <label htmlFor={'PatientDOB'} className="col-sm-4 col-form-label">{'Date of Birth'}</label>
                                <div className="col-12 col-md-8 p-0 m-0" id={'PatientDOB'}>
                                <DatePicker
                                    minDate={new Date('01-01-1000')}
                                    maxDate={new Date('12-31-9999')}
                                    placeholderText="--/--/----"
                                    selected={this.state.selectedPatient.dateOfBirth ? Date.parse(moment(this.state.selectedPatient.dateOfBirth, 'MM-DD-YYYY').toISOString()) : null}
                                    onChange={(e) => {
                                        this.setState((prevState)=>({
                                            selectedPatient: {
                                                ...prevState.selectedPatient,
                                                dateOfBirth: e
                                            }
                                        }))
                                }}
                                />
                                    <div className="row">
                                        <div className="col-12 pr-1 mb-2 m-0 text-danger verlag-bold" style={{fontSize: '1rem'}} >*please include ' / ' when entering date</div>
                                    </div>
                                </div>
                            </div>
                            {buildRow("Gender",
                                <Select
                                    isSearchable={true}
                                    placeholder={"Please Select..."}
                                    noOptionsMessage={() => "No option"}
                                    value={ getLabel(this.state.selectedPatient.genderID, this.props.genders) }
                                    onChange={(e) => this.setState((prevState)=>({
                                        selectedPatient: {
                                            ...prevState.selectedPatient,
                                            genderID: e.value
                                        }
                                    }))}
                                    className={"state_select"}
                                    options={this.props.genders}
                                />
                            , 'Gender of the patient'
                            )}
                            {buildRow("Ethnicity",
                                <Select
                                    isSearchable={true}
                                    placeholder={"Please Select..."}
                                    noOptionsMessage={() => "No option"}
                                    value={ getLabel(this.state.selectedPatient.ethnicityID, this.props.ethnicities) }
                                    onChange={(e) => this.setState((prevState)=>({
                                        selectedPatient: {
                                            ...prevState.selectedPatient,
                                            ethnicityID: e.value
                                        }
                                    }))}
                                    className={"state_select"}
                                    options={this.props.ethnicities}
                                />
                            , 'Ethnicity of the patient'
                            )}
                            {buildRow("Race",
                                <Select
                                    isSearchable={true}
                                    placeholder={"Please Select..."}
                                    noOptionsMessage={() => "No option"}
                                    value={ getLabel(this.state.selectedPatient.raceID, this.props.races) }
                                    onChange={(e) => this.setState((prevState)=>({
                                        selectedPatient: {
                                            ...prevState.selectedPatient,
                                            raceID: e.value
                                        }
                                    }))}
                                    className={"state_select"}
                                    options={this.props.races}
                                />
                            , 'Race of the patient'
                            )}
                            {buildRow("Email",
                                <input className={"form-control"}
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"Email"}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedPatient: {
                                                   ...prevState.selectedPatient,
                                                   email: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedPatient.email}
                                />
                            , 'Email'
                            )}
                            {buildRow("Phone Number",
                                <PhoneInput
                                    id={'Phone Number'}
                                    placeholder="Enter phone number"
                                    value={this.state.selectedPatient.phoneNumber}
                                    onChange={(e) => this.setState((prevState)=>({
                                        selectedPatient:{ ...prevState.selectedPatient, phoneNumber: e}
                                    }))}
                                    defaultCountry="US"
                                />, 'Phone number of the patient'
                            )}
                            {buildRow("State",
                                <Select
                                    isSearchable={true}
                                    placeholder={"Please Select..."}
                                    noOptionsMessage={() => "No option"}
                                    value={ getLabel(this.state.selectedPatient.state, this.props.states) }
                                    onChange={(e) => this.setState((prevState)=>({
                                        selectedPatient: {
                                            ...prevState.selectedPatient,
                                            state: e.value
                                        }
                                    }))}
                                    className={"state_select"}
                                    options={this.props.states}
                                />, 'State of the patient'
                            )}
                            {buildRow("Country",
                                <Select
                                    isSearchable={true}
                                    placeholder={"Please Select..."}
                                    noOptionsMessage={() => "No option"}
                                    value={ getLabel(this.state.selectedPatient.country, this.props.countries) }
                                    onChange={(e) => this.setState((prevState)=>({
                                        selectedPatient: {
                                            ...prevState.selectedPatient,
                                            country: e.value
                                        }
                                    }))}
                                    className={"state_select"}
                                    options={this.props.countries}
                                />, 'Country of the patient'
                            )}
                            {buildRow("Street Address",
                                <input className={"form-control"}
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"Street Address"}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedPatient: {
                                                   ...prevState.selectedPatient,
                                                   streetAddress: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedPatient.streetAddress}
                                />
                            , 'Street Address'
                            )}
                            {buildRow("Street Address cont.",
                                <input className={"form-control"}
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"Street Address cont."}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedPatient: {
                                                   ...prevState.selectedPatient,
                                                   streetAddress2: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedPatient.streetAddress2}
                                />
                            , 'Street Address cont.'
                            )}
                            {buildRow("City",
                                <input className={"form-control"}
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"City"}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedPatient: {
                                                   ...prevState.selectedPatient,
                                                   city: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedPatient.city}
                                />
                            , 'City'
                            )}
                            {buildRow("County",
                                <input className={"form-control"}
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"County"}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedPatient: {
                                                   ...prevState.selectedPatient,
                                                   county: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedPatient.county}
                                />
                            , 'County'
                            )}
                            {buildRow("Zipcode",
                                <input className={"form-control"}
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"Zipcode"}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedPatient: {
                                                   ...prevState.selectedPatient,
                                                   zipcode: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedPatient.zipcode}
                                />
                            , 'Zipcode'
                            )}
                            {buildRow("Facilities",
                                <Select
                                    isSearchable={true}
                                    isMulti={true}
                                    placeholder={"Please Select..."}
                                    noOptionsMessage={() => "No option"}
                                    value={ this.state.selectedPatient.FacilityIDs }
                                    onChange={(e) => this.setState((prevState)=>({
                                        selectedPatient: {
                                            ...prevState.selectedPatient,
                                            FacilityIDs: e
                                        }
                                    }))}
                                    className={"state_select"}
                                    options={getSelectLabels(this.props.facilities)}
                                />, 'Facilities patient belongs to'
                            )}


                            <div className={this.state.selectedPatient && calculateAge(this.state.selectedPatient.dateOfBirth) < 18 ? "" : "d-none"}>
                                {buildRow("Guardian First Name",
                                    <input className={"form-control"}
                                        maxLength={50}
                                        autoComplete={"off"}
                                        type={"search"}
                                        name={"Guardian First Name"}
                                        onChange={(e)=>{
                                            this.setState( (prevState) => ({
                                                selectedPatient: {
                                                    ...prevState.selectedPatient,
                                                    guardianFirstName: e.target.value
                                                }
                                            }))
                                        }}
                                        value={this.state.selectedPatient?.guardianFirstName}
                                    />
                                , 'Guardian first name'
                                )}
                                <div className="form-group row" data-toggle={'tooltip'} data-placement={'top'} title={'Guardian Last Name'}>
                                    <label htmlFor={'guardianLastName'} className="col-sm-4 col-form-label">{'Guardian Last Name'}</label>
                                    <div className="col-12 col-md-8 p-0 m-0" id={'guardianLastName'}>
                                        <input 
                                            className={"form-control"}
                                            maxLength={50}
                                            autoComplete={"off"}
                                            type={"search"}
                                            name={"Guardian Last Name"}
                                            onChange={(e)=>{
                                                this.setState( (prevState) => ({
                                                    selectedPatient: {
                                                        ...prevState.selectedPatient,
                                                        guardianLastName: e.target.value
                                                    }
                                                }))
                                            }}
                                            value={this.state.selectedPatient?.guardianLastName}
                                        />
                                        <div className="row">
                                            <div className="col-12 pr-1 mb-2 m-0 verlag-bold" style={{fontSize: '1rem'}}>*guardian info required for patients under the age of 18</div>
                                        </div>
                                    </div>
                                </div>
                                                            
                            </div>


                           
                        </div>
                        <div className="modal-footer">                            
                            <button type="button" className="btn btn-primary" onClick={() => { this.handleSubmit() }}> Submit </button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </>
        )
    }
}